export function isEmptyChatHtml(html) {
  const raw = String(html || "");
  if (/<img\b/i.test(raw)) return false;
  const text = raw
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return !text;
}

export const CHAT_QUILL_FORMATS = [
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
  "image",
];

export const CHAT_EMOJI_LIST = [
  "😀",
  "😂",
  "😍",
  "😊",
  "🤔",
  "😢",
  "👍",
  "👏",
  "🙏",
  "🎉",
  "✅",
  "❌",
  "🔥",
  "💯",
  "💪",
  "❤️",
];
